"use strict";

require("core-js/modules/es.object.define-property.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ResponsiveImage = _interopRequireDefault(require("./ResponsiveImage"));
var _default = _ResponsiveImage["default"];
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJSZXNwb25zaXZlSW1hZ2UiXSwic291cmNlcyI6WyIuLi8uLi9zcmMvUmVzcG9uc2l2ZUltYWdlL2luZGV4LmpzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZXNwb25zaXZlSW1hZ2UgZnJvbSAnLi9SZXNwb25zaXZlSW1hZ2UnO1xuXG5leHBvcnQgZGVmYXVsdCBSZXNwb25zaXZlSW1hZ2U7XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7O0FBQUE7QUFBZ0QsZUFFakNBLDJCQUFlO0FBQUEifQ==